// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/" + (chunkId === 96 ? "vendors" : chunkId) + "." + {"96":"d1ebe6b5cec155b4b2b8","225":"7f2cddf035d7c4e0600e","752":"1e8e2ea0269955fec0df"}[chunkId] + ".js";
};